import React, {Component} from 'react';
import {connect} from 'react-redux';
import './DisplayUserPhoto.scss';
import {Storage} from '../../../shared/services/aws';
class DisplayUserPhoto extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userPhotoUrl: null
    };
  }

  componentDidMount() {
    if (this.props.user.photo) {
      this.getS3Link(this.props.user.photo);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.user && nextProps.user.photo) {
      this.getS3Link(nextProps.user.photo);
    } else if (nextProps.user) {
      this.setState({
        userPhotoUrl: null
      });
    }
  }

  getS3Link(imageUrl) {
    if (imageUrl) {
      //Storage.get(imageUrl)
     //   .then(result => {
          this.setState({
            userPhotoUrl: imageUrl
         });
     //   })
     //   .catch((err) => {
     //     console.log(err);
       // });
    } else {
      this.setState({
        userPhotoUrl: null
      });
    }
  }

  render() {
    return (
      <div>
        {!this.props.displayOnHover && this.props.user.photo &&
        <div className="display-user-photo">
          <img src={`/api/v1/user-image/${this.props.user.guid}`}/>
        </div>
        }

        {!this.props.user.photo &&
        <div className="name-holder">
          {this.props.children}
        </div>
        }

        {this.props.displayOnHover && this.props.user.photo &&

        <div className="display-user-photo-on-hover">
          <div className="name-holder">
            {this.props.children}
            <i className="fa fa-picture-o"></i>
          </div>

          <div className="photo-container">
            <img src={`/api/v1/user-image/${this.props.user.guid}?=${Date.now()}`}/>
          </div>
        </div>
        }
      </div>
    );
  }
}

// ----------------------
// Redux Mappings
// ----------------------

const mapStateToProps = (state) => {
  return {};
};

export default connect(mapStateToProps)(DisplayUserPhoto);
